export default {
  page_title: 'Offer template | Thanx',
  configuration: 'Configuration',
  usage_redemption: 'Usage and Redemption',
  where_its_used: "Where it's used",
  created_on: 'Created on %{date}',
  archived_on: 'Archived on %{date}',
  back: 'Back',
  send_a_test: 'Send a test',
  reward_restrictions_disclaimer:
    'Some restrictions (such as expiration dates, minimum purchase requirements, and maximum discounts) currently apply only to campaign-issued offers and the marketplace. Offers granted through other channels may not include these restrictions.',
  reward_id_copied_to_clipboard: 'Offer ID copied to clipboard',
  copy_reward_id: 'Copy Offer ID',
  get_reward_id: 'Get offer ID',
  reward_id_modal_title: 'Offer ID',
  reward_id_modal_subtitle:
    'Use this Offer ID when distributing this offer through external tools, partners, or integrations.',
  copy: 'Copy',
  no_id_available: 'No ID available',
  cards: {
    reward_details: {
      title: 'Offer details',
      reward_type: 'Offer type',
      template_id: 'Offer ID',
      discount: 'Discount amount',
      number_of_uses: 'Number of uses',
      exactly_once_description:
        'After this offer is used or expires, no additional offers are issued to the same customer.',
      multiple_times_set_number_description:
        'Customers can redeem up to %{count} times within %{days} days.',
      multiple_times_unlimited_description:
        'Customers can redeem the offer up to %{count} times in total.',
      retail_price: 'Retail price',
      how_it_appears: 'How it appears to customers',
      long_description: 'Description on the offer detail screen',
      how_many_bonus_points: 'How many bonus %{currencyName} customers get',
      // Bonus-points copy stays "reward" per LOY-623 scope; rendered only in the
      // isBonusPoints fallback branch of RewardDetailsCard.tsx.
      will_apply_instantly:
        'This reward will apply instantly. Customers will not see it in the reward list.',
      cost_to_business: 'Cost to business',
      max_redemption_cost: 'Max redemption cost',
    },
    online_redemption: {
      hidden_menu: {
        title: 'Show this hidden menu to customers',
        name: 'Hidden Menu',
        info: 'This menu will be visible only to customers that get this reward',
        header: 'Menu header',
        custom_image: 'Show a custom image',
        congrats: 'Congratulations!',
        unlocked_menu: "You've unlocked a secret menu.",
        top_of_the_menu:
          'Customers see this banner at the top of the menu (app) or left of the menu (web). This banner is there to show customers that they are looking at a hidden menu.',
        show_default_message: 'Show the default message',
      },
      title: 'Online redemption',
      able_to_redeem: 'Customers are able to redeem this offer online',
      info: 'How the offer is redeemed online',
      items_discounted: 'Items that get discounted',
      items_not_available:
        'These items are no longer available from your ordering provider',
      modifiers_not_available:
        'These modifiers are no longer available from your ordering provider',
      show_less: 'Show less',
      show_more: 'Show %{count} more',
      zero_price_item_warning:
        "This item has a $0 base price and can't be discounted by this offer.",
      items_required: 'Items required for the discount',
      not_redeemable: 'Not redeemable online',
      free_modifier_items: 'Items free modifiers are applied to',
      no_modifiers:
        'All items selected above are eligible regardless of modifiers.',
      discounted_modifier_items: 'Items discounted modifiers are applied to',
      modifier_discounts: 'Modifier discounts',
      not_available:
        'Online redemption is only available when you have Thanx Ordering configured. ',
      contact_us: 'Contact us to learn more.',
      will_apply_lowest:
        'Discount will apply to the lowest priced item in cart',
      will_apply_lowest_free_item:
        'Any selected items with any selected modifiers are eligible for this offer. If customer has more than one of the items above, the free item will be the lowest priced item in their cart.',
      will_apply_lowest_free_modifier:
        'Any selected modifiers on any selected items are eligible for this offer. If customer has more than one eligible modifiers, the offer will apply to the lowest priced modifier in their cart.',
      then_entire_purchase:
        "Then they'll get a discount off their entire purchase",
      // Bonus-points copy intentionally stays "reward" per LOY-623 scope; these
      // online/instore strings render only in the campaign bonus-points preview
      // (Online.tsx / Instore.tsx, redeem_type === 'points/static').
      will_apply_instantly:
        'This reward will apply instantly the next time customers sign in to the app or web experience.',
    },
    instore_redemption: {
      title: 'In-store redemption',
      info: 'How the offer is redeemed in-store',
      redemption: 'Redemption',
      not_available: 'Not redeemable in-store',
      manager_comp: 'Manager comp',
      golden_ticket_info:
        'Customer can redeem in-store via the app by showing the screen to staff.',
      manager_comp_info:
        'Any restrictions must be enforced by staff or POS at checkout.',
      automatic_cash_back: 'Automatic cash back',
      redemption_image: {
        title: 'Redemption image',
        no_image: 'No image provided',
      },
      url: {
        title: 'Where this image links',
        no_url: 'This image does not include a link',
      },
      coupon_codes: {
        redemption: 'Redemption',
        enforced_by_pos: 'Enforced by POS',
        type: 'Type',
        integration: 'Integration between Thanx and the POS',
        entered_by_customer:
          'Each customer will be issued a unique QR code at redemption.<br/>Or customers can enter their phone number or email at the POS.<br/>Then Thanx tells the POS which offers are available to redeem for that customer.',
        issued_5_digit_code:
          'Each customer will be issued a unique 5 digit code at redemption.',
        pos_free_product_ids: 'Free items',
        pos_free_item_modifier_ids: 'Modifier restrictions (optional)',
        pos_free_modifier_ids: 'Free modifiers',
        pos_free_modifier_item_ids: 'Items',
        pos_discounted_product_ids:
          'POS Product IDs for items that get discounted in-store',
        pos_discounted_modifier_ids:
          'POS Modifier IDs for modifiers that get discounted in-store',
        pos_no_modifiers:
          'All items selected above are eligible regardless of modifiers.',
        pos_modifier_discount_ids: 'Modifier discounts',
        pos_required_product_ids: 'Items customer must buy',
        discounted_item_modifier_text:
          'Any selected items with any selected modifiers are eligible for this offer. If customer has more than one of the items above, the free item will be the lowest priced item in their cart.',
        discounted_modifier_text:
          'Any selected modifiers on any selected items are eligible for this offer. If customer has more than one eligible modifiers, the offer will apply to the lowest priced modifier in their cart.',
        format: 'Format',
        static_code: 'Static coupon code',
        pool_of_unique: 'Pool of unique codes',
        coupon_pool_details: 'coupon pool details',
        coupon_code: 'Coupon code',
        total_codes: 'Total codes',
        redeemed_codes: 'Redeemed codes (not available)',
        not_available_to_use:
          'These codes were applied to an offer that was redeemed by a customer',
        available_codes: 'Available codes',
        available_to_use:
          'These are available to use in new campaigns or to grant for customer support',
      },
      // Bonus-points copy intentionally stays "reward" per LOY-623 scope; these
      // online/instore strings render only in the campaign bonus-points preview
      // (Online.tsx / Instore.tsx, redeem_type === 'points/static').
      will_apply_instantly:
        'This reward will apply instantly the next time customers sign in to the app or web experience.',
    },
    multi_use: {
      title: 'Number of uses',
      exactly_once_label: 'Exactly once',
      exactly_once_description:
        'After this offer is used or expires, no additional offers are issued to the same customer.',
      multiple_times_label: 'Multiple times',
      multiple_times_description:
        'Customers can redeem this offer more than once, depending on the rules you define.',
      max_redemptions_label: 'Max redemptions',
      max_redemptions_limited_description:
        'Customers can redeem the offer up to %{count} times in total.',
      active_window_duration_label:
        'How long the customer has to use all offers after the campaign is sent',
      active_window_duration_description:
        'After %{days} days any outstanding offers will expire.',
      max_issuances_per_window_label: 'How many times can this offer be used',
      max_issuances_per_window_set_number: 'Set number of times',
      max_issuances_per_window_unlimited: 'Unlimited times',
      max_issuances_per_window_description:
        'Customers can redeem up to %{count} times within %{days} days.',
    },
    customer_support: {
      title: 'Customer support',
      available:
        'Available to grant to an individual customer when responding to customer feedback or providing customer support.',
      not_available:
        'Not available to grant to an individual customer when responding to customer feedback or providing customer support.',
    },
    minimum_spend: {
      title: 'Minimum spend',
      value: 'Must spend at least $%{amount} to redeem',
      not_set: 'No minimum spend required',
    },
    maximum_discount: {
      title: 'Maximum discount',
      value: 'Cannot redeem more than $%{amount}',
      not_set: 'No maximum discount limit',
    },
  },
  usage: {
    title: 'Where this offer template is used',
    no_campaigns:
      'This offer template is not used in any campaigns or programs',
    create_a_campaign: 'Create a new campaign',
    rewards_issued: 'Offers issued',
    rewards_redeemed: 'Offers redeemed',
    redemption_rate: 'Redemption rate',
    table: {
      name: 'Name',
      type: 'Type',
      rewards_issued: 'Offers\nissued',
      rewards_redeemed: 'Offers\nredeemed',
      redemption_rate: 'Redemption\nrate',
      campaign_status: 'Campaign or\nprogram status',
    },
  },
}
